module.exports = __webpack_public_path__ + "static/media/icon_advisory.661ea7f9.svg";